import {useState, useRef, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {
  MainContentWrapperStyle,
  ViewMoreTextStyled,
  ContentWrapper,
} from './ContentContainer.styles';

import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';

// Omniture Imports
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

const ContentContainer: React.FC<{
  children: React.ReactNode;
  heightToBeVisible: number;
  scrollToId?: string;
  wrapperStyles?: object;
}> = ({children, heightToBeVisible, scrollToId, wrapperStyles}) => {
  const [showMore, updateShowMore] = useState(false);
  const [visibleContentHeight, updateVisibleContentHeight] = useState();
  const [originalContentHeight, updateOriginalContentHeight] = useState();
  const [showLimitedData, updatesLimitedData] = useState(false);
  const dispatch = useDispatch();

  const container = useRef();
  const content = useRef();

  const showMoreClickHandler = e => {
    e.preventDefault();
    updateShowMore(!showMore);
    {
      !showMore
        ? updateVisibleContentHeight(originalContentHeight)
        : updateVisibleContentHeight(heightToBeVisible);
    }
    if (scrollToId && showMore) scrollToEl(scrollToId);
    dispatch(
      omnitureThunk(omnitureConfig.pages.Details, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.AboutProperty}_${
            showMore
              ? detailsClick.aboutProperty.hideClicked
              : detailsClick.aboutProperty.viewMoreClicked
          }`,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.AboutProperty,
          destination: '',
        },
      }),
    );
  };

  useEffect(() => {
    if (content.current) {
      let contentHeight = content?.current?.offsetHeight;
      updateOriginalContentHeight(contentHeight);
      if (contentHeight > heightToBeVisible) {
        updatesLimitedData(true);
        updateVisibleContentHeight(heightToBeVisible);
      } else {
        updateVisibleContentHeight(contentHeight);
      }
    }
  }, []);

  return (
    <MainContentWrapperStyle ref={container} $wrapperStyles={wrapperStyles}>
      <ContentWrapper ref={content} height={`${visibleContentHeight}px`}>
        {children}
      </ContentWrapper>

      {!!showLimitedData && (
        <ViewMoreTextStyled onClick={showMoreClickHandler}>
          {showMore ? 'Read Less' : 'Read More'}
        </ViewMoreTextStyled>
      )}
    </MainContentWrapperStyle>
  );
};

export default ContentContainer;
